import { render, staticRenderFns } from "./InboxDetail.vue?vue&type=template&id=e1ed674e&scoped=true&"
import script from "./InboxDetail.vue?vue&type=script&lang=js&"
export * from "./InboxDetail.vue?vue&type=script&lang=js&"
import style0 from "./InboxDetail.vue?vue&type=style&index=0&id=e1ed674e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ed674e",
  null
  
)

export default component.exports